(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bravmen-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function shuffleReviews(scope) {
    scope.querySelectorAll('[data-bm-review-section]').forEach(function (section) {
      if (section.dataset.bmReviewRotated === 'true') return;
      var primary = section.querySelector('[data-bm-review-primary]');
      var extra = section.querySelector('[data-bm-review-extra]');
      if (!primary) return;
      var cards = Array.prototype.slice.call(primary.children);
      if (extra) cards = cards.concat(Array.prototype.slice.call(extra.children));
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = cards[i];
        cards[i] = cards[j];
        cards[j] = temp;
      }
      cards.forEach(function (card, index) {
        if (index < 6 || !extra) primary.appendChild(card);
        else extra.appendChild(card);
      });
      section.dataset.bmReviewRotated = 'true';
    });
    scope.querySelectorAll('.bm-proof-teaser').forEach(function (teaser) {
      if (teaser.dataset.bmTeaserRotated === 'true') return;
      var quotes = teaser.querySelectorAll('[data-bm-proof-quote]');
      if (!quotes.length) return;
      var chosen = Math.floor(Math.random() * quotes.length);
      quotes.forEach(function (quote, index) { quote.hidden = index !== chosen; });
      teaser.dataset.bmTeaserRotated = 'true';
    });
  }
  function prepareVideoLoading(root) {
    if (!('IntersectionObserver' in window)) return;
    var videos = root.querySelectorAll('.bm-social-proof video[data-bm-video][preload="none"]');
    if (videos.length === 0) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.preload = 'metadata';
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    videos.forEach(function (video) { observer.observe(video); });
  }
  function initializeReviews(root) {
    shuffleReviews(root);
    prepareVideoLoading(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeReviews(document); }, { once: true });
  } else {
    initializeReviews(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeReviews(event.target); });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bravmen-selection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadHoverImage(event) {
    if (!(event.target instanceof Element)) return;
    if (event.type === 'pointerover' && window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = event.target.closest('.bm-selection .bm-product-card');
    if (!card || card.dataset.bmHoverRequested === 'true') return;
    var template = card.querySelector('template.bm-product-hover-template');
    var holder = card.querySelector('.bm-product-photo');
    if (!template || !holder) return;
    var image = template.content.querySelector('img');
    if (!image) return;
    card.dataset.bmHoverRequested = 'true';
    var imageCopy = image.cloneNode(true);
    imageCopy.loading = 'eager';
    imageCopy.addEventListener('load', function () {
      card.classList.add('bm-product-card--hover-ready');
    }, { once: true });
    imageCopy.addEventListener('error', function () {
      imageCopy.remove();
    }, { once: true });
    holder.insertBefore(imageCopy, template.nextSibling);
    if (imageCopy.complete && imageCopy.naturalWidth > 0) {
      card.classList.add('bm-product-card--hover-ready');
    }
  }
  document.addEventListener('pointerover', loadHoverImage, { passive: true });
  document.addEventListener('focusin', loadHoverImage);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
